import { createColumnHelper } from '@tanstack/react-table';
import { lt } from '@mews/framework';
import { Typography } from '@optimus-web/core';
import { ContractingTableRowData } from '../types';
import { ActionCell } from '../cells/ActionCell';
import { SignatureStatusCell } from '../../../common/cells/SignatureStatusCell';
import { ExpirationDate } from '../../../common/cells/ExpirationDate';
import { LinkedReservationsLabel } from '../../../common/components/linkedReservations/LinkedReservationsLabel';

const columnHelper = createColumnHelper<ContractingTableRowData>();

export const useContractingTableColumns = ({ customerId }: { customerId: string }) => [
    columnHelper.accessor('name', {
        id: 'name',
        enableSorting: true,
        header: () => lt('ContractGuestProfileNameLabel'),
        cell: (props) => (
            <Typography textStyle="bodyMedium" as="div">
                {props.getValue()}
            </Typography>
        ),
        meta: {
            width: 450,
        },
    }),
    columnHelper.accessor('linkedReservation', {
        id: 'linkedReservation',
        enableSorting: true,
        header: () => lt('ContractGuestProfileLinkedReservation'),
        cell: ({ getValue }) => <LinkedReservationsLabel customerId={customerId} reservationId={getValue()} />,
    }),
    columnHelper.accessor('signatureStatus', {
        id: 'signatureStatus',
        enableSorting: true,
        header: () => lt('ContractGuestProfileSignatureStatus'),
        cell: ({ getValue, row }) => (
            <SignatureStatusCell
                status={getValue()}
                signatureDate={row.original.signatureDate}
                expirationDate={row.original.expirationDate}
            />
        ),
    }),
    columnHelper.accessor('expirationDate', {
        id: 'expirationDate',
        enableSorting: true,
        header: () => lt('ContractGuestProfileExpirationDate'),
        cell: ({ row }) => <ExpirationDate expirationDate={row.original.expirationDate} />,
    }),
    columnHelper.display({
        id: 'actions',
        cell: () => <ActionCell />,
        meta: {
            align: 'end',
            width: 60,
        },
    }),
];
